const initial = {
  accessToken: "",
  email: "",
  id: "",
  name: "",
  picture: {
    data: {
      height: 50,
      with: 50,
      url: "",
    },
  },
  signedRequest: "",
  userID: "",
};

// Actions
export const setUser = (user) => ({
  type: "SET_USER",
  payload: user,
});

// Reducer
const User = (state = initial, action) => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...action.payload,
      };

    default:
      return state;
  }
};

export default User;
